// オブジェクトの作成
var KIWASEISAKUJO = KIWASEISAKUJO || {}

/**
 * GETパラメータ取得
 * @param {*} query 
 * @returns 
 */
KIWASEISAKUJO['getParams'] = (query) => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {}
    for (let i = 0; i < query.length; i++) {
        params[query[i]] = searchParams.get(query[i])
    }
    return params
}

/**
 * セクションの更新（フェッチ）
 * @param {*} url 
 * @param {*} headers 
 * @returns 
 */
KIWASEISAKUJO['updateSections'] = (url, headers) => {
    return new Promise((resolve, reject) => {
        fetch(url, headers)
        .then(res => res.json())
        .then(res => resolve(res))
        .catch(error => reject(error))
    })
}
/**
 * 検索関連
 */
KIWASEISAKUJO['Search'] = {
    init: () => {
      const targetForm = document.forms['search']
      const targetFormRecipe = document.forms['search-recipe']
    
      if (targetForm) {
        targetForm.addEventListener('submit', (e) => KIWASEISAKUJO.Search.submitEvt(e))
        KIWASEISAKUJO.Search.setQueryFields()
      } 
      if (targetFormRecipe){
        targetFormRecipe.addEventListener('submit', (e) => KIWASEISAKUJO.Search.submitEvtRecipe(e))
        KIWASEISAKUJO.Search.setQueryFieldsRecipe()
      }
      
      KIWASEISAKUJO.Search.sortToggle()
  
    },
    /**
     * 検索内容の送信(パーツ)
     * @param {*} e 
     */
    submitEvt: (e) => {
      e.preventDefault()
      KIWASEISAKUJO.Search.setQuery(e.target)
      e.target.submit()
    },
        /**
     * 検索内容の送信(レシピ)
     * @param {*} e 
     */
      submitEvtRecipe: (e) => {
        e.preventDefault()
        KIWASEISAKUJO.Search.setQueryRecipe(e.target)
        e.target.submit()
      },
    /**
     * なしの場合にdisabled解除(パーツ)
     * @param {*} target 
     */
    setQuery: (target) => {
      for (let i = 0; i < target.elements['q'].length; i++) {
        if (target.elements['q'][i].value === '' && target.elements['q'][i].classList.contains('keyword')) {
          target.elements['q'][i].value = '*'
        }
      }
  
    },
    /**
     * なしの場合にdisabled解除(レシピ)
     * @param {*} target 
     */
    setQueryRecipe: (target) => {
      for (let i = 0; i < target.elements['q'].length; i++) {
        if (target.elements['q'][i].value === '' && target.elements['q'][i].classList.contains('keyword_recipe')) {
          target.elements['q'][i].value = '*'
        }
      }
  
    },
    /**
     * 検索条件の変更を押した際のURL生成
     */
    // queryChangeEvt: () => {
    // //   const query = ['q', 'filter.p.m.info.product_type', 'filter.v.m.info.category', 'filter.v.price.gte', 'filter.v.price.lte', 'filter.v.availability']
    //   const query = ['q', 'filter.p.m.info.category', 'filter.v.price.gte', 'filter.v.price.lte']
    //   const params = KIWASEISAKUJO.getParams(query)
    //   location.href = encodeURI(`/search?type=product&keyword=${params.q ? encodeURIComponent(params.q) : ''}&category=${params['filter.p.m.info.category'] ? encodeURIComponent(params['filter.p.vendor']) : ''}&item=${params['filter.p.m.im-ft.item_category'] ? encodeURIComponent(params['filter.p.m.im-ft.item_category']) : ''}&price_1=${params['filter.v.price.gte'] ? encodeURIComponent(params['filter.v.price.gte']) : ''}&price_2=${params['filter.v.price.lte'] ? encodeURIComponent(params['filter.v.price.lte']) : ''} : ''}`)
    // },
    /**
     * 検索フィールドのセット(パーツ)
     */
    setQueryFields: () => {
      const ecSearch = document.querySelector('.ec-search')
    //   const query = ['keyword', 'brand', 'item', 'color', 'price_1', 'price_2', 'sort_by']
      const query = ['keyword', 'category', 'price_1', 'price_2']
      let params = KIWASEISAKUJO.getParams(query)
    //   const query2 = ['q', 'filter.p.vendor', 'filter.p.m.im-ft.item_category', 'filter.v.m.im-ft.vcolor', 'filter.v.price.gte', 'filter.v.price.lte', 'sort_by', 'filter.v.availability']
    const query2 = ['q', 'filter.p.m.info.category', 'filter.v.price.gte', 'filter.v.price.lte']  
    let params2 = KIWASEISAKUJO.getParams(query2)
  
      if (!ecSearch) {
        return false
      }
      if (params.keyword === null && params.category === null && ecSearch.dataset.searchResults === '0') {
        params.keyword = params2['q']
        params.category = params2['filter.p.m.info.category']
        params.price_1 = params2['filter.v.price.gte']
        params.price_2 = params2['filter.v.price.lte']
        // params.availability = params2['filter.v.availability']
      }
      Object.keys(params).forEach((query) => {
        let key = query
        if (query === 'keyword') key = 'q'
        if (query === 'category') key = 'filter.p.m.info.category'
        if (query === 'price_1') key = 'filter.v.price.gte'
        if (query === 'price_2') key = 'filter.v.price.lte'
        // if (query === 'availability') key = 'filter.v.availability'
        const target = document.querySelector('form[name="search"] input[name="' + key + '"]')
        if (target && params[query]) {
          target.value = params[query] == '*' ? '' : decodeURIComponent(params[query])
        }
      })
    },
    /**
     * 検索フィールドのセット(レシピ)
     */
    setQueryFieldsRecipe: () => {
      const ecSearch = document.querySelector('.ec-search-recipe')
      const query = ['keyword_recipe', 'category_recipe', 'level', 'price_1', 'price_2']
      let params = KIWASEISAKUJO.getParams(query)
    //   const query2 = ['q', 'filter.p.vendor', 'filter.p.m.im-ft.item_category', 'filter.v.m.im-ft.vcolor', 'filter.v.price.gte', 'filter.v.price.lte', 'sort_by', 'filter.v.availability']
    const query2 = ['q', 'filter.p.m.info.category', 'filter.p.m.info.level', 'filter.v.price.gte', 'filter.v.price.lte']
    let params2 = KIWASEISAKUJO.getParams(query2)
  
      if (!ecSearch) {
        return false
      }
      if (params.keyword_recipe === null && params.category === null && params.level === null && ecSearch.dataset.searchResults === '0') {
        params.keyword_recipe = params2['q']
        params.category_recipe = params2['filter.p.m.info.category']
        params.level = params2['filter.p.m.info.level']
        params.price_1 = params2['filter.v.price.gte']
        params.price_2 = params2['filter.v.price.lte']
        // params.availability = params2['filter.v.availability']
      }
      Object.keys(params).forEach((query) => {
        let key = query
        if (query === 'keyword_recipe') key = 'q'
        if (query === 'category_recipe') key = 'filter.p.m.info.category'
        if (query === 'level') key = 'filter.p.m.info.level'
        if (query === 'price_1') key = 'filter.v.price.gte'
        if (query === 'price_2') key = 'filter.v.price.lte'
        // if (query === 'availability') key = 'filter.v.availability'
        const target = document.querySelector('form[name="search-recipe"] input[name="' + key + '"]')
        if (target && params[query]) {
          target.value = params[query] == '*' ? '' : decodeURIComponent(params[query])
        }
      })
    },
    /**
     * 検索オプションのラベルなどのセット
     * @param {*} target 
     * @param {*} params 
     * @param {*} query 
     */
    setOptions: (target, params, query) => {
      const options = target.closest('div').querySelectorAll('.js-option')
      options.forEach(option => {
        if (option.dataset.value === decodeURIComponent(params[query])) {
          option.classList.add('active')
          target.closest('div').querySelector('.js-label').innerHTML = option.dataset.label
        } else {
          option.classList.remove('active')
        }
      })
    },
    /**
     * ソートボタンのクリックイベント
     */
    sortToggle: () => {
      const btn = document.querySelector('._sortOpener')
      const menu = document.querySelector('._sortMenu')
      if (!btn) return false
      btn.addEventListener('click', e => menu.classList.toggle('open'))
      KIWASEISAKUJO.Search.changeSort(btn)
      KIWASEISAKUJO.Search.changeAvailability(btn)
    },
    /**
     * ソートを変更した際の挙動
     */
    changeSort: (btn) => {
      const sort = document.querySelectorAll('input[name="sortState"]')
      sort.forEach((elm) => {
        elm.addEventListener('change', async (e) => {
          const target = document.querySelector('#product-grid')
          let urls = new URL(window.location.href);
  
          // URLSearchParamsオブジェクトを取得
          let params = urls.searchParams;
  
          params.set('sort_by', e.target.dataset.sort);
          history.pushState({}, '', '/search?' + params.toString())
  
          btn.querySelector('._select').innerHTML = e.target.dataset.id
  
          const url = `?sections[]=${target.dataset.id}&sections_url=${window.location.pathname}&${params.toString()}`
          const result = await KIWASEISAKUJO.updateSections(url, {})
          KIWASEISAKUJO.ajaxUpdate(result[target.dataset.id], '#product-grid')
          btn.click(true)
        })
      })
    },
    /**
     * 在庫有無のイベント
     */
    changeAvailability: (btn) => {
      const availability = document.querySelector('input[name="onlyInStock"]')
      const target = document.querySelector('#product-grid')
  
      availability.addEventListener('change', async (e) => {
        let urls = new URL(window.location.href)
        let params = urls.searchParams;
  
        params.set('filter.v.availability', e.target.checked ? '1' : '')
        history.pushState({}, '', '/search?' + params.toString())
  
        const url = `?sections[]=${target.dataset.id}&sections_url=${window.location.pathname}&${params.toString()}`
        const result = await KIWASEISAKUJO.updateSections(url, {})
        KIWASEISAKUJO.ajaxUpdate(result[target.dataset.id], '#product-grid')
        KIWASEISAKUJO.ajaxUpdate(result[target.dataset.id], '#storeitems_head')
        btn.click(true)
        KIWASEISAKUJO['Search'].init()
      })
    }
  }